export default __webpack_public_path__ + "_/shared_modules/base-layout/img/favicon-c15a902d974176198b77bde3f8fb7b57.ico";